/* CO premium: revelados discretos. No modifica formularios, carrito ni FAQ. */
(() => {
  if (window.__coPremiumMotionInstalled) return;
  window.__coPremiumMotionInstalled = true;

  const selector = [
    '.co-vc__header',
    '.co-new__head-text',
    '.co-editorial-lifestyle__eyebrow',
    '.co-editorial-lifestyle__title',
    '.co-editorial-lifestyle__text'
  ].join(', ');

  const motionAllowed = () => !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let observer = null;

  function init(root = document) {
    const home = document.querySelector('#MainContent[data-template="index"]');
    if (!home || !motionAllowed()) return;
    const targets = (root === document ? home : root).querySelectorAll(selector);
    if (!('IntersectionObserver' in window)) return;
    if (!observer) {
      observer = new IntersectionObserver((entries) => {
        entries.forEach(({ target, isIntersecting }) => {
          if (!isIntersecting) return;
          target.classList.add('co-premium-visible');
          observer.unobserve(target);
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -32px 0px' });
    }
    targets.forEach((el) => {
      if (el.dataset.coPremiumObserved === '1') return;
      el.dataset.coPremiumObserved = '1';
      /* Elementos ya fuera del primer viewport pueden entrar sin flash. */
      el.classList.add('co-premium-rise');
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  /* Si el navegador suspende IntersectionObserver, el contenido reaparece. */
  window.addEventListener('load', () => {
    window.setTimeout(() => {
      document.querySelectorAll('.co-premium-rise:not(.co-premium-visible)')
        .forEach((el) => el.classList.add('co-premium-visible'));
    }, 3000);
  }, { once: true });
})();
